import axios, { AxiosError } from "axios";

import { Utils } from "utils";
import { GraphhopperErrorStatus } from "constants/enums";

export const googleInstance = axios.create({
  baseURL: "https://maps.googleapis.com/maps/api/",
  params: {
    key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  },
});

export const openStreetInstance = axios.create({
  baseURL: "https://nominatim.openstreetmap.org/",
});

export const graphhopperInstance = axios.create({
  baseURL: "https://graphhopper.com/api/1",
});

export const dataForSeoInstance = axios.create({
  baseURL: "https://api.dataforseo.com/v3",
  auth: {
    username: "alexander@sweetcode.pro",
    password: "f6ae6b1686248915",
  },
  headers: {
    "content-type": "application/json",
  },
});

console.log({ keys: process.env.REACT_APP_GRAPHHOPPER_API_KEYS });
const graphhopperApiKeys = JSON.parse(
  process.env.REACT_APP_GRAPHHOPPER_API_KEYS!
) as string[];

graphhopperInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const err = error as AxiosError<any>;
    const { status, message } = Utils.Graphhopper.decodeError(error);

    /* Check Request Status */
    /* If 429 => Tty next Graphhopper Api Key */
    if (status === GraphhopperErrorStatus.MinutelyLimit && err.config) {
      const url = new URL(err.config.url ?? "");
      const currentKey = url.searchParams.get("key");

      const currentKeyIndex = graphhopperApiKeys.findIndex(
        (i) => i === currentKey
      );

      /* If current key is last => just return an error */
      /* If not => set next API Key to request */
      if (currentKeyIndex !== graphhopperApiKeys.length - 1) {
        const updatedGraphhopperKey = graphhopperApiKeys[currentKeyIndex + 1];
        url.searchParams.set("key", updatedGraphhopperKey);

        return axios.request({ ...err.config, url: url.toString() });
      }
    }

    return Promise.reject(new Error(`${status}: ${message}`));
  }
);
